export interface UploadEntry {
  uuid: string
  error: string | null
  file: File
  progress: number
}
type Action =
  | { type: "ADD"; entries: UploadEntry[] }
  | { type: "PROGRESS"; uuid: string; progress: number }
  | { type: "ERROR"; uuid: string; message: string }
  | { type: "REMOVE"; uuid: string }

export function uploadQueueReducer(
  state: UploadEntry[],
  action: Action,
): UploadEntry[] {
  switch (action.type) {
    case "ADD":
      return [...state, ...action.entries]
    case "PROGRESS":
      return state.map((e) =>
        e.uuid === action.uuid ? { ...e, progress: action.progress } : e,
      )
    case "ERROR":
      return state.map((e) =>
        e.uuid === action.uuid ? { ...e, error: action.message } : e,
      )
    case "REMOVE":
      return state.filter((e) => e.uuid !== action.uuid)
    default:
      return state
  }
}
